<ion-header>
    <ion-toolbar>
      <ion-title>{{ 'Substitutions' | translate }}</ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="dismiss()">
          <ion-icon slot="icon-only" name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <ion-toggle class="allow-toggle-btn" [(ngModel)]="allowSubstitutions">Allow Substitutions</ion-toggle>
    <form [formGroup]="form">
        @if(allowSubstitutions){
            <ion-list>
                <ion-item>
                    <ion-select 
                        label="{{ 'Number of substitutions per match' | translate }}" 
                        label-placement="stacked" 
                        interface="popover" 
                        formControlName="perMatch"
                        placeholder="Select number">
                        @for (number of substitutionOptions; track number) {
                          <ion-select-option [value]="number">
                            @if (unlimitedSubstitutions) {
                                    &#9733;&#9733;&#9733;
                                 } @else {
                                    {{ number }}
                            }
                        </ion-select-option>
                        }
                    </ion-select>
                </ion-item>
                <ion-item>
                    <ion-select 
                        label="{{ 'Number of substitutions per set' | translate }}" 
                        label-placement="stacked" 
                        interface="popover" 
                        formControlName="perSet"
                        placeholder="Select number"
                        >
                        @for (number of substitutionOptions; track number) {
                            <ion-select-option [value]="number">
                                @if (unlimitedSubstitutions) {
                                    &#9733;&#9733;&#9733;
                                  } @else {
                                    {{ number }}
                                }
                            </ion-select-option>
                        }
                    </ion-select>
                </ion-item>
                <ion-text class="error" color="danger" *ngIf="form.errors?.substitutionMismatch">
                  substitutions per match must be greater than or equal to substitutions per set.
                </ion-text>
                
                <ion-item  lines="none" class="ion-text-center ion-padding">
                    <ion-title lines="none">OR</ion-title>
                </ion-item>
                <ion-item >
                    <ion-toggle [ngModelOptions]="{standalone: true}" (ionChange)="unlimitedSubstitutionsToggle()" [(ngModel)]="unlimitedSubstitutions">Unlimited Substitutions</ion-toggle>
                </ion-item>
            </ion-list>
        }
    </form>
  </ion-content>
  <ion-footer>
    <ion-toolbar>
      <ion-button [disabled]="form.errors" color="primary" class="ion-margin" (click)="save()" expand="block">
        Save
      </ion-button>
    </ion-toolbar>
  </ion-footer>